<template>
<div>
  <div v-if="$store.state.pageLoaded" class="filter-wrapper">
    <md-field>
      <label>Odaberite ekran</label>
      <md-select v-model="screen">
        <md-option v-for="screen in screens" :value="screen.id"> {{ screen.screen }} </md-option>
      </md-select>
    </md-field>
    <md-button v-if="screen"  class="md-raised md-dense md-primary" v-on:click="setScreen()">Prikaži</md-button>
  </div>
  <div class="theatre-container theatre-container-admin screen" id="screen" ref="screen">
    <div class="theatre" v-if="visible" >
      <ul class="theatre-legend">
        <li v-for="category, key in $store.state.theatre.pricelist_data.category" :class="'c-'+key" v-if="key != 0" ><span>{{ key }}</span>{{ formatCurrency(category[1]) }}</li>
        <li class="c-disabled"><span>0</span>Zauzeto</li>
      </ul>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="-20 -30 595 473" preserveAspectRatio="xMidYMid meet" class="places">
        <Row v-for="(row, rowID) in $store.state.theatre.rows" :model="{id: rowID, row: row}" :disabled="true"/>
        <g class="row-numbers">
          <text v-for="label in $store.state.labels[$store.state.currentStageKind]" :x="label.x" :y="label.y" :style="label.style">{{ label.value }}</text>
        </g>
      </svg>
      <!-- <div class="theatre-seats-holder">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 550 490" preserveAspectRatio="xMidYMid meet">
          <Row v-for="(row, rowID) in $store.state.theatre.rows" :model="{id: rowID, row: row}"/>
        </svg>
      </div> -->
    </div>
    <div v-show="!visible">
      <div v-for="(img, index) in images" v-show="index==image"><img class="image" :src="img"></div>
    </div>
  </div>
</div>
</template>
<script>
import {mapGetters} from 'vuex';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ShowScreen',
  data(){
    return {
      screen: null,
      screens: [],
      performance: 0,
      visible: false,
      images: [],
      image: 0,
      interval: null,
    }
  },
  mixins: [FormatCurrency],
  computed: {
    ...mapGetters([
      'isPageLoaded',
    ])
  },
  methods: {
    async loaded(){
      const imageUrl = 'https://res.cloudinary.com/dg86xjjts/image/upload/';
      const pictures = ['v1590149194/nicbdvxokqvd6gkhfifp','v1521042708/xvgx3yrarlj3mzo7aftq','v1521042698/t1pslkpjumthptnjbcau'];
      for(var p in pictures){
        this.images.push(imageUrl+pictures[p]);
      }
      await this.$store.dispatch('getShowScreens');
      this.screens = this.$store.state.receivedData.showScreens;
      this.$store.state.pageLoaded = true;
    },
    async getPerformance(){
      await this.$store.dispatch('getShowScreen', this.screen);
      this.performance = this.$store.state.receivedData.showScreen.list[0].performance;
      if(this.performance == null){
        return false;
      }
      await this.$store.dispatch('getTheatre', {url: `${this.$store.state.urls.performances}${this.performance}/`});
      return true;
    },
    async setScreen(){
      this.visible = await this.getPerformance();
      var elem = this.$refs.screen;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }
      if(!this.interval){
        this.startInterval();
      }
    },
    startInterval(){
      this.interval = setInterval(async ()=>{ 
        this.visible = await this.getPerformance();
        if(!this.visible){
          if(this.image == this.images.length-1){
            this.image = 0;
          }else{
            this.image++;
          }
        }
      }, 5000);
    }
  },
  mounted(){
    this.loaded();
  },
}
</script>
<style lang="scss">
.screen{
  background: white;
  width:100%;
  text-align: center;
}

.theatre-seats{
  border: 0;
}

.row-numbers text{
  font-size: 8px;
  transform: translateY(-1px);
  font-weight: bold;
}

.theatre-container{
  position: relative;
}

.places{
  height: 93vh;
}

.image{
  height: 100vh!important;
  object-fit: contain;
}

.theatre-legend{
	display: flex;
	list-style-type: none;
	padding: 13px 0 10px;
	border: solid #000;
	border-width: 1px 0 1px 0;
  place-content: center;
  font-weight: bold;
	li{
		font-size: 14px;
		line-height: 1;
		& + li{
			margin-left: 20px;
		}

		&.c-1 span{
			background-color: #910f13!important;
		}
		&.c-2 span{
			background-color: #c5b358!important;
		}
		&.c-3 span{
			background-color: #19853c!important;
		}
		&.c-4 span{
			background-color: #0068ac!important;
		}
		&.c-disabled span{
			background-color: #e9e9e9!important;
		}

		span{
			display: inline-block;
			vertical-align: middle;
			font-size: 0;
			width: 14px;
			height: 14px;
			border-radius: 50%;
			margin: -3px 5px 0 0;
		}
	}
}

.seat{
	cursor: pointer;
	circle{
		fill: #e9e9e9!important;
		transition: fill 150ms, stroke 150ms;
		stroke-width: 2px;
	}

	text{
		font-size: 4px;
		fill: white!important;
	}

	&[disabled="disabled"]{
		circle{
			fill: #e9e9e9!important;
		}
	}

	&.s-available{
		&:not([disabled="disabled"]){
			&.c1 circle{
				fill: #910f13!important;
			}
			&.c2 circle{
				fill: #c5b358!important;
			}
			&.c3 circle{
				fill: #19853c!important;
			}
			&.c4 circle{
				fill: #0068ac!important;
			}
		}
	}
}

.theatre-seats-holder{
	text-align: center;
	overflow: hidden;
	div{
		position: relative;
		&:after{
			content: "";
			display: block;
			padding-top: 90%;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Tickets/ShowScreen.vue